<template>
  <c-row>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap Collapse</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/collapse"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <c-button color="primary" @click="collapse = !collapse">
            Toggle Collapse
          </c-button>
          <c-collapse :show="collapse" class="mt-2">
            <c-card body-wrapper>
              <c-card-text>Collapse contents Here</c-card-text>
              <c-button size="sm" color="secondary" @click="innerCollapse = !innerCollapse">
                Toggle Inner Collapse
              </c-button>
              <c-collapse :show="innerCollapse" class="mt-2">
                <c-card body-wrapper>Hello!</c-card>
              </c-collapse>
            </c-card>
          </c-collapse>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header class="btn text-left" @click="cardCollapse = !cardCollapse">
          <strong>Collapsible card</strong>
        </c-card-header>
        <c-collapse :show="cardCollapse">
          <c-card-body>
            {{ text }}
          </c-card-body>
        </c-collapse>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
export default {
  name: 'Collapses',
  data() {
    return {
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      text: `
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
        richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
        brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
        tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
        assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
        wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
        vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
        synth nesciunt you probably haven't heard of them accusamus labore VHS.
      `,
    };
  },
};
</script>
